define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/table/matrix/Path"
], function(declare, _, PathMatrix) {

	return declare(PathMatrix, {

		_filterNodes : function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			//TA28473: Refine this matrix to display the list of unique styles.
			return _.uniq(nodes);
		}
	});
});